import React from "react";
import {useTranslation} from "react-i18next";

import MDInput from "materialDashboard/components/MDInput";
import {getIn} from "formik";


const labelFnWithoutCode = (r) => r.description;
const labelFnWithCode = (r) => `${r.code} - ${r.description}`


const IncidentSelect = ({
                           name,
                           registry,
                           formik,
                           labelFn,
                           onChange,
                           labelWithCode = false,
                           attrValue = 'code',
                           ...props
                       }) => {
    const {t} = useTranslation(['incidents']);

    const value = getIn(formik.values, name);
    const error = getIn(formik.errors, name);
    const touched = getIn(formik.touched, name);

    const renderLabel = labelFn ?? (labelWithCode ? labelFnWithCode : labelFnWithoutCode);

    return <MDInput select
                    SelectProps={{native: true}} // use native select to support select-by-typing and arrow select without opening menu
                    name={name}
                    label={t(`incidentForm.${name}`)}
                    value={value ?? ''}
                    onChange={onChange === undefined ? formik.handleChange : onChange}
                    error={touched && Boolean(error)}
                    helperText={touched && error}
                    variant="standard"
                    fullWidth
                    {...props}>
        <option label=""></option>
        {
            registry.map((r) => <option key={r[attrValue]} value={r[attrValue]}>{renderLabel(r)}</option>)
        }
    </MDInput>
}

export default IncidentSelect;